module.exports = __webpack_public_path__ + "img/raiffeisen-logo.775ee69a.png";